import ReviewAttribute from "../../../Components/SharedComponent/ReviewAttribute/ReviewAttribute";
import ReviewSummarySectionHeading from "../../../Components/SharedComponent/ReviewSummarySectionHeading/ReviewSummarySectionHeading";
import { DataNotFound } from "../../../Components/SharedComponent/ReviewSummarySectionNotFound/DataNotFound";
import { toTitleCase } from "../../../Utils/stringUtls";
import {
  cardActivationMethod,
  cardActivationParameter,
  cardChannelAll,
  cardPlacement,
  cardReloadingOptions,
  cardholderNotify,
  cardsActivationChannel,
  consumerFundingSource,
  corporateFundingSource,
  customerSupportChannel,
  customerSupportProviders,
  kycResponsibility,
  notificationChannels,
} from "../ProgramFeatures/stringUtils";

const PrepaidProgramFeatures = ({ data }) => {
  if (!data) return <DataNotFound />;

  const {
    pf_enable_kyc_conduct,
    pf_enable_kyc_conduct_no_reason,
    pf_kyc_conduct,
    pf_kyc_conduct_other,
    pf_kyc_conduct_other_company,
    pf_kyc_conduct_other_contact_name,
    pf_kyc_conduct_other_title,
    pf_kyc_conduct_other_phone,
    pf_kyc_conduct_other_email,
    pf_kyc_conduct_other_address,
    pf_funding_source_consumer_option = [],
    pf_funding_source_corporate_option,
    pf_funding_source_corporate_other_company,
    pf_funding_source_corporate_other_contact_name,
    pf_funding_source_corporate_other_title,
    pf_funding_source_corporate_other_phone,
    pf_funding_source_corporate_other_phone_country,
    pf_funding_source_corporate_other_email,
    pf_funding_source_corporate_other_address,
    pf_card_placement,
    pf_card_placement_channel = [],
    pf_card_placement_channel_other,
    pf_supplimentary_cards_permitted,
    pf_supplimentary_cards_age_limit,
    supplimentary_cards_own_profile,
    supplimentary_cards_share_primary_balance,
    pf_card_activation_required,
    pf_card_activation_method,
    pf_card_activation_channels = [],
    pf_card_activation_channels_other,
    pf_card_offline_pin_required,
    pf_cardholder_notifications,
    pf_cardholder_notifications_channels,
    pf_customer_support_channels = [],
    pf_customer_support_provider,
    pf_customer_support_provider_other_company,
    pf_customer_support_provider_other_contact_name,
    pf_customer_support_provider_other_title,
    pf_customer_support_provider_other_phone,
    pf_customer_support_provider_other_phone_country,
    pf_customer_support_provider_other_email,
    pf_card_activation_parameters = [],
    pf_card_reloading_options = [],
    pf_card_reloading_options_other,
    pf_card_closure_how_will_card_be_closed,
    pf_card_closure_how_will_card_account_balance_be_treated_at_card_closure,
  } = data["1_1"];

  return (
    <div className="forms-instance" style={{ color: "#111" }}>
      <ReviewSummarySectionHeading title="Program Features" />
      <div i2c-grid="grid" className="review-summary-gap">
        <div i2c-grid="12@md">
          <div className="review-summary-section-heading mb-8 mt-16">
            Card Holder Authentication
          </div>
          <ReviewAttribute
            label="Would you like KYC enabled for this program?"
            value={
              pf_enable_kyc_conduct?.length
                ? toTitleCase(pf_enable_kyc_conduct)
                : "-"
            }
          />
        </div>
        {pf_enable_kyc_conduct === "no" ? (
          <ReviewAttribute
            label="Reason"
            value={
              pf_enable_kyc_conduct_no_reason?.length
                ? pf_enable_kyc_conduct_no_reason
                : "-"
            }
          />
        ) : null}
        {pf_enable_kyc_conduct === "yes" ? (
          <div i2c-grid="12@md">
            <div className="review-summary-section-heading mb-8">
              Who will conduct KYC?
            </div>
            <div i2c-grid="grid gap-sm">
              {pf_kyc_conduct === "other" && (
                <>
                 <ReviewAttribute
                  label="Who will conduct KYC?"
                  value={
                    kycResponsibility.find(
                      (res) => res.value === pf_kyc_conduct,
                    )?.label ?? "-"
                  }
                />
                </>
              )}
            </div>
          </div>
        ) : null}
        <div i2c-grid="12@md">
          <div className="review-summary-section-heading">
            Funding Source for the Cards
          </div>
        </div>
        <div i2c-grid="6@md">
          <ReviewAttribute
            label="Loaded by the consumer through"
            value={
              pf_funding_source_consumer_option?.length
                ? consumerFundingSource
                    .map((source) =>
                      pf_funding_source_consumer_option.includes(source.value)
                        ? source.label
                        : null,
                    )
                    .filter(Boolean)
                    .join(", ")
                : "-"
            }
          />
        </div>
        <div i2c-grid="6@md">
          <ReviewAttribute
            label="Loaded by the corporate entity through"
            value={
              pf_funding_source_corporate_option?.length
                ? corporateFundingSource.find(
                    (opt) => opt.value === pf_funding_source_corporate_option,
                  )?.label
                : "-"
            }
          />
        </div>

        {pf_funding_source_corporate_option === "other" ? (
          <div i2c-grid="12@md">
            <div i2c-grid="grid" className="review-summary-gap">
              <>
                <div i2c-grid="12@md" className="review-summary-section-heading">
                  3rd Party vendor details
                </div>
                <ReviewAttribute
                  label="Name"
                  value={
                    pf_funding_source_corporate_other_company?.length
                      ? toTitleCase(pf_funding_source_corporate_other_company)
                      : "-"
                  }
                />
                <ReviewAttribute
                  label="Contact name"
                  value={
                    pf_funding_source_corporate_other_contact_name?.length
                      ? toTitleCase(
                          pf_funding_source_corporate_other_contact_name,
                        )
                      : "-"
                  }
                />

                <ReviewAttribute
                  label="Title"
                  value={
                    pf_funding_source_corporate_other_title?.length
                      ? pf_funding_source_corporate_other_title
                      : "-"
                  }
                />
                <ReviewAttribute
                  label="Phone"
                  value={
                    pf_funding_source_corporate_other_phone?.length
                      ? pf_funding_source_corporate_other_phone
                      : "-"
                  }
                />
                <ReviewAttribute
                  label="Phone Country"
                  value={
                    pf_funding_source_corporate_other_phone_country?.length
                      ? pf_funding_source_corporate_other_phone_country
                      : "-"
                  }
                />
                <ReviewAttribute
                  label="Email"
                  value={
                    pf_funding_source_corporate_other_email?.length
                      ? toTitleCase(pf_funding_source_corporate_other_email)
                      : "-"
                  }
                />
                <ReviewAttribute
                  label="Physical Address"
                  value={
                    pf_funding_source_corporate_other_address?.length
                      ? toTitleCase(pf_funding_source_corporate_other_address)
                      : "-"
                  }
                />
              </>
            </div>
          </div>
        ) : null}

        <div i2c-grid="12@md">
          <div className="review-summary-section-heading">
            How Cards will be ordered?
          </div>
        </div>

        <ReviewAttribute
          label="Card Order Placement"
          value={
            pf_card_placement &&
            Array.isArray(pf_card_placement) &&
            pf_card_placement.length > 0
              ? pf_card_placement
                  .map(
                    (value) =>
                      cardPlacement.find((opt) => opt.value === value)?.label,
                  )
                  .filter(Boolean)
                  .join(", ")
              : "-"
          }
        />

        {pf_card_placement_channel &&
          Array.isArray(pf_card_placement_channel) &&
          pf_card_placement_channel.length > 0 && (
            <ReviewAttribute
              label="Card Order Placement Channels"
              value={pf_card_placement_channel
                .map((value) => {
                  if (value === "other") {
                    const otherLabel =
                      cardChannelAll.find((ind) => ind.value === value)
                        ?.label || "Other";
                    return pf_card_placement_channel_other
                      ? `(${pf_card_placement_channel_other})`
                      : otherLabel;
                  }
                  return cardChannelAll.find((ind) => ind.value === value)
                    ?.label;
                })
                .filter(Boolean)
                .join(", ")}
            />
          )}

        <div
          i2c-grid="12@md"
          className="review-summary-section-heading no-text-wrap"
        >
          Secondary/Supplementary Cards
        </div>
        <ReviewAttribute
          label="Are secondary/supplementary cards permitted?"
          value={
            pf_supplimentary_cards_permitted?.length
              ? toTitleCase(pf_supplimentary_cards_permitted)
              : "-"
          }
        />

        <ReviewAttribute
          label="Is the seconday supplementary card 18+?"
          value={
            pf_supplimentary_cards_age_limit?.length
              ? toTitleCase(pf_supplimentary_cards_age_limit)
              : "-"
          }
        />
        {pf_supplimentary_cards_permitted === "yes" ? (
          <>
            <ReviewAttribute
              label="Will the secondary cards have their own profile?"
              value={
                supplimentary_cards_own_profile?.length
                  ? toTitleCase(supplimentary_cards_own_profile)
                  : "-"
              }
            />
            <ReviewAttribute
              label="If Yes, will they share balance with the Primary Card?"
              value={
                supplimentary_cards_share_primary_balance?.length
                  ? toTitleCase(supplimentary_cards_share_primary_balance)
                  : "-"
              }
            />
          </>
        ) : null}

        <div
          i2c-grid="12@md"
          className="review-summary-section-heading no-text-wrap"
        >
          Activation Required?
        </div>
        <ReviewAttribute
          label="Activation Required?"
          value={
            pf_card_activation_required?.length
              ? pf_card_activation_required
              : "-"
          }
        />
        {pf_card_activation_required === "yes" ? (
          <>
            <div
              i2c-grid="12@md"
              className="review-summary-section-heading no-text-wrap"
            >
              Card Activation Channels
            </div>
            <ReviewAttribute
              label="Card Activation Channels"
              value={pf_card_activation_channels
                .map((opt) =>
                  cardsActivationChannel.find((op) => op.value === opt)
                    ?.label === "Other"
                    ? pf_card_activation_channels_other
                    : cardsActivationChannel.find((op) => op.value === opt)
                        ?.label,
                )
                .filter(Boolean)
                .join(", ")}
            />
            <ReviewAttribute
              label="Card Activation Parameters"
              value={
                pf_card_activation_parameters?.length
                  ? pf_card_activation_parameters
                      .map(
                        (value) =>
                          cardActivationParameter.find(
                            (opt) => opt.value === value,
                          )?.label,
                      )
                      .filter(Boolean)
                      .join(", ")
                  : "-"
              }
            />
          </>
        ) : (
          <>
            <div
              i2c-grid="12@md"
              className="review-summary-section-heading no-text-wrap"
            >
              Card Activation Method
            </div>
            <ReviewAttribute
              label="Card Activation Method"
              value={
                pf_card_activation_method?.length
                  ? cardActivationMethod.find(
                      (opt) => opt.value === pf_card_activation_method,
                    )?.label
                  : "-"
              }
            />
          </>
        )}
        <div
          i2c-grid="12@md"
          className="review-summary-section-heading no-text-wrap"
        >
          Offline PIN
        </div>
        <ReviewAttribute
          label="Offline PIN"
          value={
            pf_card_offline_pin_required?.length
              ? toTitleCase(pf_card_offline_pin_required)
              : "-"
          }
        />
        <div
          i2c-grid="12@md"
          className="review-summary-section-heading no-text-wrap"
        >
          Cardholder Notifications
        </div>
        <ReviewAttribute
          label="Cardholder Notifications"
          value={
            pf_cardholder_notifications?.length
              ? cardholderNotify.find(
                  (opt) => opt.value === pf_cardholder_notifications,
                )?.label
              : "-"
          }
        />
        <ReviewAttribute
          label="Select the channel through which alerts data will be shared."
          value={
            pf_cardholder_notifications_channels?.length
              ? Array.isArray(pf_cardholder_notifications_channels)
                ? pf_cardholder_notifications_channels
                    .map((channel) => {
                      // For "send-to-holders" use notificationChannels, otherwise use push/smpp options
                      if (pf_cardholder_notifications === "send-to-holders") {
                        return notificationChannels.find(
                          (opt) => opt.value === channel,
                        )?.label;
                      } else {
                        return [
                          { label: "PUSH", value: "push" },
                          { label: "SMPP", value: "smpp" },
                        ].find((opt) => opt.value === channel)?.label;
                      }
                    })
                    .filter(Boolean)
                    .join(", ")
                : pf_cardholder_notifications === "send-to-holders"
                  ? notificationChannels.find(
                      (opt) =>
                        opt.value === pf_cardholder_notifications_channels,
                    )?.label
                  : [
                      { label: "PUSH", value: "push" },
                      { label: "SMPP", value: "smpp" },
                    ].find(
                      (opt) =>
                        opt.value === pf_cardholder_notifications_channels,
                    )?.label
              : "-"
          }
        />

        <div
          i2c-grid="12@md"
          className="review-summary-section-heading no-text-wrap"
        >
          Customer Support Channel
        </div>
        <ReviewAttribute
          label="Customer Support Channel"
          value={
            pf_customer_support_channels?.length
              ? customerSupportChannel
                  .map((source) =>
                    pf_customer_support_channels?.includes(source.value)
                      ? source.label
                      : null,
                  )
                  .filter(Boolean)
                  .join(", ")
              : "-"
          }
        />
        <ReviewAttribute
          label="Who will provide customer support?"
          value={
            customerSupportProviders.find(
              (provider) => provider.value === pf_customer_support_provider,
            )?.label ?? "-"
          }
        />
        {pf_customer_support_provider === "client-third-party" ? (
          <div i2c-grid="12@md">
            <div i2c-grid="grid gap-sm">
              <div
                i2c-grid="12@md"
                className="fw-500 review-summary-sub-heading"
              >
                Client/Third Party
              </div>
              <ReviewAttribute
                label="Name"
                value={
                  pf_customer_support_provider_other_company?.length
                    ? toTitleCase(pf_customer_support_provider_other_company)
                    : "-"
                }
              />
              <ReviewAttribute
                label="Contact name"
                value={
                  pf_customer_support_provider_other_contact_name?.length
                    ? toTitleCase(
                        pf_customer_support_provider_other_contact_name,
                      )
                    : "-"
                }
              />

              <ReviewAttribute
                label="Title"
                value={
                  pf_customer_support_provider_other_title?.length
                    ? pf_customer_support_provider_other_title
                    : "-"
                }
              />
              <ReviewAttribute
                label="Phone"
                value={
                  pf_customer_support_provider_other_phone?.length
                    ? pf_customer_support_provider_other_phone
                    : "-"
                }
              />
              <ReviewAttribute
                label="Phone Country"
                value={
                  pf_customer_support_provider_other_phone_country?.length
                    ? pf_customer_support_provider_other_phone_country
                    : "-"
                }
              />
              <ReviewAttribute
                label="Email"
                value={
                  pf_customer_support_provider_other_email?.length
                    ? toTitleCase(pf_customer_support_provider_other_email)
                    : "-"
                }
              />
            </div>
          </div>
        ) : null}
        <div
          i2c-grid="12@md"
          className="review-summary-section-heading no-text-wrap"
        >
          Card Reloading Options
        </div>
        <ReviewAttribute
          label="Card Reloading Options"
          value={
            pf_card_reloading_options?.length
              ? pf_card_reloading_options
                  .map((value) =>
                    value === "other"
                      ? pf_card_reloading_options_other || "Other"
                      : cardReloadingOptions.find((opt) => opt.value === value)
                          ?.label,
                  )
                  .filter(Boolean)
                  .join(", ")
              : "-"
          }
        />
        <div
          i2c-grid="12@md"
          className="review-summary-section-heading no-text-wrap"
        >
          Card Closure
        </div>
        <ReviewAttribute
          label="How will the card accounts be closed?"
          value={
            pf_card_closure_how_will_card_be_closed?.length
              ? pf_card_closure_how_will_card_be_closed
              : "-"
          }
        />
        <ReviewAttribute
          label="How will the card account balance be treated at card closure?"
          value={
            pf_card_closure_how_will_card_account_balance_be_treated_at_card_closure?.length
              ? pf_card_closure_how_will_card_account_balance_be_treated_at_card_closure
              : "-"
          }
        />
      </div>
    </div>
  );
};
export default PrepaidProgramFeatures;
